import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';
import CouponStatus from '../../mixins/coupon.status.mixin';
import { CallNative } from '../../../services/EpicContextService/call.native';
import CreateMonerisOrder from '../../shared/CreateMonerisOrder/create.moneris.order.vue';

export interface Coupon {
    id: number;
    title: string;
    img: string;
    slogan: string;
    expirationDate: string;
    price: number;
    condition: string;
    status?: number;
    insId?: number;
}

@Component(
    {
        components: {
            CreateMonerisOrder
        },
    }
)
export default class HybridCouponCard extends Mixins(CouponStatus) {
    public orderInfo: any = {};
    public invalid: boolean = true;
    public configs = new CommonConfig();
    @Prop({ default: false})
    public hideStatus!: boolean;
    public fjjUserId = null;

    @Prop({ default: function() {
        const config = new CommonConfig();
        return {
            id: 1,
            title: '买房有好礼',
            img: config.rifoDesignAssetsUrl + '/hybrid/maifangcoupon%402x.png',
            slogan: '现在起买房即送$500好礼，快来抢',
            expirationDate: '2019-04-06',
            price: 500,
            condition: '买满5000减500',
            status: 3001
        };
    } })
    public coupon!: Coupon;
    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(globalPudge: any, globalPudgeOld: any) {
        const fjjUserId = globalPudge.getParam('fjjUserId');
        if (fjjUserId) {
            this.fjjUserId = fjjUserId;
        }
    }
    public created() {
        this.invalid = this.coupon.status === this.COUPON_INSTANCE_STATUS['USED']
        || this.coupon.status === this.COUPON_INSTANCE_STATUS['EXPIRED']
        || this.coupon.status === this.COUPON_INSTANCE_STATUS['REFUNDED']
        || this.coupon.status === this.COUPON_INSTANCE_STATUS['DISCARDED'];
    }
    public goOrder() {
        CallNative.runNativeFun('nativeGoOrder');
    }
    public goBuy() {
        if (localStorage) {
            localStorage.setItem('rifo_coupon_id', `${this.coupon.id}`);
        }
        (this.$refs.monerisForm as any).monerisSubmit();
    }
    public navTo(link: string, event: MouseEvent) {
        if ((event.target  as Element).nodeName !== 'BUTTON') {
            if (
                this.coupon.status === this.COUPON_INSTANCE_STATUS['USED']
            || this.coupon.status === this.COUPON_INSTANCE_STATUS['EXPIRED']
            || this.coupon.status === this.COUPON_INSTANCE_STATUS['REFUNDED']
            || this.coupon.status === this.COUPON_INSTANCE_STATUS['DISCARDED']) {
                return;
            }
            this.$router.push(link);
        }
    }
    public appointment() {
        if (!this.coupon.insId) {
            console.log('no coupon instance id');
            return;
        }
        this.$router.push(`/hybrid/services/appointment/${this.coupon.insId}`);
    }
}
